import React from 'react';
import { Button } from '../../../ui/Button';
import { usePropertyFormContext } from '../contexts/PropertyFormContext';
import { ApartmentCriteria } from './Criteria/ApartmentCriteria';
import { HouseCriteria } from './Criteria/HouseCriteria';
import { FormField } from '../components/FormField';
import { PromotionCriteria } from './Criteria/PromotionCriteria';
import { LandCriteria } from './Criteria/LandCriteria';
import { CommercialCriteria } from './Criteria/CommercialCriteria';

interface CriteriaProps {
  onNext: () => void;
}

export const Criteria: React.FC<CriteriaProps> = ({ onNext }) => {
  const { formData, property, handleInputChange } = usePropertyFormContext();
  const isApartment = formData.propertyType?.toLowerCase().includes('appartement');
  const isHouse = formData.propertyType?.toLowerCase().includes('maison');
  const isPromotion = formData.propertyType?.toLowerCase() === 'promotion';
  const isLand = formData.propertyType?.toLowerCase() === 'terrain';
  const isCommercial = formData.propertyType?.toLowerCase() === 'commerce';

  const renderCriteria = () => {
    if (isCommercial) {
      return <CommercialCriteria formData={formData} handleInputChange={handleInputChange} />;
    }
    if (isPromotion) {
      return <PromotionCriteria formData={formData} property={property} handleInputChange={handleInputChange} />;
    }
    if (isLand) {
      return <LandCriteria formData={formData} handleInputChange={handleInputChange} />;
    }
    if (isApartment) {
      return <ApartmentCriteria formData={formData} handleInputChange={handleInputChange} />;
    }
    if (isHouse) {
      return <HouseCriteria formData={formData} handleInputChange={handleInputChange} />;
    }
    return (
      <FormField label="Options">
        <div className="grid grid-cols-2 gap-6">
          <div className="space-y-4">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasParking"
                checked={formData.hasParking || false}
                onChange={handleInputChange}
              />
              <span>Parking</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasAirConditioning"
                checked={formData.hasAirConditioning || false}
                onChange={handleInputChange}
              />
              <span>Climatisation</span>
            </label>
          </div>
        </div>
      </FormField>
    );
  };

  return (
    <div className="space-y-6">
      {renderCriteria()}
      <div className="flex justify-end">
        <Button onClick={onNext}>
          Suivant
        </Button>
      </div>
    </div>
  );
};